import gql from 'graphql-tag';

export const SAVE_ATTACHED_IMAGE = gql`
  mutation saveAttachedImage($image: Upload) {
    saveAttachedImage(image: $image) {
      imageUrls
    }
  }
`;
